(function () {
  /* ─────────────────────────────────────────
     CONFIG
  ───────────────────────────────────────── */
  var FORMS_SEL = '[data-forms-id="forms-root-946236"] shopify-forms-embed';
  var EMBED_SEL = 'shopify-forms-embed';
  var MAX_RETRIES = 120;
  var RETRY_MS = 100;

  /* ─────────────────────────────────────────
     SHARED HELPERS
  ───────────────────────────────────────── */

  /** Returns the shadow root once available, or null */
  function getShadow(sel) {
    var embed = document.querySelector(sel || EMBED_SEL);
    return embed && embed.shadowRoot ? embed.shadowRoot : null;
  }

  /**
   * Keeps retrying fn() until it returns true or max attempts reached.
   * fn receives (shadow, attempt).
   */
  function waitForShadow(fn, sel, max) {
    max = max || MAX_RETRIES;
    var attempt = 0;
    function tick() {
      if (attempt >= max) return;
      var shadow = getShadow(sel);
      if (shadow) { fn(shadow); return; }
      attempt++;
      setTimeout(tick, RETRY_MS);
    }
    tick();
  }

  /**
   * Injects a <style> block into shadow exactly once (keyed by id).
   */
  function injectStyle(shadow, id, css) {
    if (shadow.querySelector('#' + id)) return;
    var style = document.createElement('style');
    style.id = id;
    style.textContent = css;
    shadow.appendChild(style);
  }

  /* ─────────────────────────────────────────
     1. TERMS CHECKBOX  (runs immediately, before DOMContentLoaded)
        Waits for the shadow + submit button, then injects the
        "agree to T&C" checkbox above the submit button.
  ───────────────────────────────────────── */
  (function initTermsCheckbox() {
    var attempt = 0;

    function run() {
      if (attempt++ >= MAX_RETRIES) return;

      var shadow = getShadow(FORMS_SEL);
      if (!shadow) return setTimeout(run, RETRY_MS);
      if (shadow.querySelector('[data-b2b-cb]')) return; // already injected

      var btn =
        shadow.querySelector("button[type='submit']") ||
        shadow.querySelector('[class*="formSubmitButton"]') ||
        shadow.querySelector('._formSubmitButton_cit2d_96');

      if (!btn || !btn.parentNode) return setTimeout(run, RETRY_MS);

      /* ── Build wrapper ── */
      var wrap = document.createElement('div');
      wrap.setAttribute('data-b2b-cb', '');

      var tId = 'b2b-939310-t';

      var row = document.createElement('div');
      var checkbox = document.createElement('input');
      checkbox.type = 'checkbox';
      checkbox.id = tId;

      var label = document.createElement('label');
      label.htmlFor = tId;
      label.innerHTML =
        '* I have read and agree with the ' +
        '<a href="/policies/terms-of-service">Terms of use</a>' +
        ' and <a href="/policies/privacy-policy">Privacy Policy</a>';

      row.appendChild(checkbox);
      row.appendChild(label);

      var error = document.createElement('div');
      error.textContent = 'Please agree to the Terms of Use and Privacy Policy.';
      error.style.color = 'red';
      error.style.fontSize = '13px';
      error.style.display = 'none';

      wrap.appendChild(row);
      wrap.appendChild(error);

      btn.parentNode.insertBefore(wrap, btn);

      /* ── Marketing info text below submit button ── */
      if (!shadow.querySelector('[data-b2b-info]')) {
        var info = document.createElement('div');
        info.setAttribute('data-b2b-info', '');

        info.innerHTML =
          '<p class="b2b-info-heading">Marketing Tools &amp; Assets:</p>' +
          '<p class="b2b-info-text">As an Aretha partner, you\'ll receive access to the Aretha Cloud (no login required), featuring beautiful product photos, videos, and marketing materials for our brands. Share your email address to receive access and explore!</p>' +
          '<p class="b2b-info-heading">Wholesaler Requirements:</p>' +
          '<p class="b2b-info-text">We put our hearts into our brands, so we want to partner with amazing retailers who want to bring amazing products to people. We provide marketing support, education, and guidance to help ensure our brands are being represented according to our standards.</p>';

        btn.parentNode.insertBefore(info, btn.nextSibling);
      }

      /* ── Disable btn until checked ── */
      btn.disabled = true;
      btn.style.opacity = '0.6';
      btn.style.cursor = 'not-allowed';

      checkbox.addEventListener('change', function () {
        if (checkbox.checked) {
          btn.disabled = false;
          btn.style.opacity = '1';
          btn.style.cursor = 'pointer';
          error.style.setProperty('display', 'none', 'important');
        } else {
          btn.disabled = true;
          btn.style.opacity = '0.6';
          btn.style.cursor = 'not-allowed';
          error.style.setProperty('display', 'block', 'important');
        }
      });

      btn.addEventListener('click', function (e) {
        setTimeout(function () {
          if (!checkbox.checked) {
            e.preventDefault();
            e.stopPropagation();
            error.style.setProperty('display', 'block', 'important');
          } else {
            error.style.setProperty('display', 'none', 'important');
          }
        }, 0);
      });

      /* ── All form styles injected once here ── */
      injectStyle(shadow, 'b2b-main-style', `
        form._formFieldset_cit2d_82 { gap: 16px !important; }

        fieldset legend,
        p._textBody_2aowh_10,
        legend._textBody_2aowh_10 {
          font-size: 16px !important;
          font-weight: 600 !important;
        }

        legend.custom-legend._textBody_2aowh_10 {
          padding-bottom: 10px;
        }

        ._horizontalLayout_1hja3_14 {
          grid-template-columns: 1fr 1fr !important;
          gap: 16px !important;
        }

        ._checkboxField_1hja3_3 ._textBody_2aowh_10 {
          font-size: 14px !important;
          line-height: 140% !important;
          letter-spacing: 0 !important;
          color: #272727 !important;
          cursor: pointer !important;
        }

        form input[type="checkbox"] {
          appearance: none !important;
          width: 1.8rem !important;
          height: 1.8rem !important;
          background: rgb(249,247,239) !important;
          border: 1px solid rgba(39,39,39,0.4) !important;
          cursor: pointer !important;
          display: inline-block !important;
          margin: 0 !important;
          outline: none !important;
          position: relative !important;
          transition: background-color 0.3s, border-color 0.3s, box-shadow 0.2s !important;
          vertical-align: top !important;
          border-radius: 0.3rem !important;
          flex: 0 0 auto !important;
        }

        form input[type="text"],
        form input[type="tel"] {
          padding-block: 15px;
        }

        ._radioInput_nw6va_31 {
          height: 15px !important;
          width: 15px !important;
        }

        form input[type="checkbox"]:checked {
          background: rgb(39,39,39) !important;
          border: 1px solid rgb(39,39,39) !important;
        }

        form input[type="checkbox"]::after {
          content: "";
          display: block;
          position: absolute;
          border: 1.5px solid rgb(249,247,239);
          border-inline-start: 0;
          border-block-start: 0;
          width: 0.4rem;
          height: 0.8rem;
          inset-inline-start: 0.6rem;
          inset-block-start: 0.3rem;
          transform: rotate(43deg);
        }

        ._formFieldContainer_1mxsl_5[data-show="false"] { display: none !important; }
        ._formFieldContainer_1mxsl_5[data-show="true"]  { display: flex !important; }

        form [data-b2b-cb] {
          display: flex !important;
          flex-direction: column !important;
          gap: 16px !important;
        }

        form [data-b2b-cb] > div {
          display: flex !important;
          gap: 8px;
        }

        form [data-b2b-cb] > div label {
          font-size: 14px !important;
          line-height: 140% !important;
          letter-spacing: 0 !important;
          color: #272727 !important;
          cursor: pointer !important;
        }

        form [data-b2b-cb] > div label a { color: #272727 !important; }

        div._formFieldContainer_1mxsl_5 label {
          border-radius: 10px !important;
          box-shadow: none !important;
          font-size: 13px !important;
          font-weight: 400 !important;
          letter-spacing: 0 !important;
          color: #00000080 !important;
          top: unset !important;
          bottom: 22% !important;
        }

        label#label-phone_number { display: none; }

        button._formSubmitButton_cit2d_96 {
          font-size: 16px !important;
          font-weight: 500 !important;
          letter-spacing: 0.75px !important;
          border-radius: 10px !important;
          text-transform: uppercase !important;
        }

        ._inline_1q1d2_47 ._formContainer_1q1d2_30 { max-width: 600px !important; }

        legend.custom-legend._textBody_2aowh_10.custom-legend-phone {
          padding-bottom: 0 !important;
        }

        .required-star { color: red; }

        .custom-hide-label { display: none !important; }

        ._formFieldContainer_1mxsl_5:has(.b2b-trim-error.visible) label {
          bottom:33% !important;
        }

        section._formHeader_cit2d_24 h2._textHeading_2aowh_35{
          font-size:32px;
          font-family:"Bricolage Grotesque" !important;
          color: #272727;
        }

        section[data-testid="banner-success"] h2._formBannerHeading_z5ku3_9{
          font-size:28px;
          font-family:"Bricolage Grotesque" !important;
          color: #272727;
          margin-bottom: 15px;
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 18px;
        }

        section[data-testid="banner-success"] h2._formBannerHeading_z5ku3_9:before {
          content: "";
          display: block;
          background-image: url(https://cdn.shopify.com/s/files/1/1675/8337/files/button.svg?v=1776659909);
          height: 56px;
          width: 56px;
        }

        section[data-testid="banner-success"] ._textBody_2aowh_10 p{
          font-size:16px;
          color:#000000;
          font-family:Poppins, sans-serif !important;
          font-weight: 400;
        }

        section[data-testid="banner-success"] ._textBody_2aowh_10 a{
          line-height: 7;
          background: #9ED28F;
          padding: 17px 35px;
          border-radius: 8px;
          font-family: 'Poppins';
          font-weight: 500;
          font-size: 16px;
        }

        label[for="label-custom#what_are_the_main_professional_haircare_brands_you_have_currentl"],
        label[for="label-custom#how_many_hairstylists_do_you_currently_have_1_1"]{
          display:none;
        }

        form [data-b2b-info] {
          margin-top: 20px !important;
          display: flex !important;
          flex-direction: column !important;
          gap: 10px !important;
        }

        form [data-b2b-info] .b2b-info-heading {
          font-size: 13px !important;
          font-weight: 600 !important;
          color: #272727 !important;
          margin: 0 0 2px !important;
          line-height: 140% !important;
        }

        form [data-b2b-info] .b2b-info-text {
          font-size: 12px !important;
          font-weight: 400 !important;
          color: #555 !important;
          margin: 0 !important;
          line-height: 150% !important;
        }
      `);
    }

    run();
  })();

  /* ─────────────────────────────────────────
     2. ALL DOM-READY FEATURES
  ───────────────────────────────────────── */
  document.addEventListener('DOMContentLoaded', function () {

    /* ── 2a. Error message customiser (interval-based) ── */
    setInterval(function updateErrors() {
      var shadow = getShadow();
      if (!shadow) return;

      /* Hide "others" field by default */
      var othersField = shadow.querySelector('[id*="custom#others"]');
      if (othersField) {
        var othersWrapper = othersField.closest('label') || othersField.closest('div');
        if (othersWrapper) othersWrapper.style.display = 'none';
      }

      shadow.querySelectorAll('[role="alert"]').forEach(function (errorEl) {
        if (!errorEl.textContent.toLowerCase().includes('required')) return;

        var label = '';
        var fieldset = errorEl.closest('fieldset') ||
          (errorEl.parentElement && errorEl.parentElement.tagName.toLowerCase() === 'fieldset'
            ? errorEl.parentElement : null);

        if (fieldset) {
          label = (fieldset.querySelector('legend') || {}).textContent || '';
        } else if (errorEl.closest('[class*="_formFileInput"]')) {
          label = ((errorEl.closest('[class*="_formFileInput"]').querySelector('p') || {}).textContent) || '';
        } else {
          var prev = errorEl.previousElementSibling;
          if (prev && prev.querySelector('label')) {
            label = prev.querySelector('label').textContent.replace(/\*/g, '');
          }
        }

        label = label.toLowerCase().trim();

        var messages = {
          'salon instagram':          'Please enter your Instagram handle.',
          'salon name':               'Please enter your salon name.',
          'location':                 'Please select atleast one location.',
          'hear':                     'Please select an option.',
          'brands are you interested':'Please select brand.',
          'trade license certificate':'Please upload a copy of your trade license.',
          'vat certificate':          'Please upload your VAT certificate.',
          'my position':              'Please enter your job title/position.',
          'my name':                  'Please enter your name.',
          'professional haircare':    'Please add brands currently used in your salon.',
          'hairstylists':             'Please enter the number of stylists.',
          'others':                   'Others field is required',
          'email':                    'Please enter a valid email address.',
          'phone':                    'Please enter a valid phone number.',
        };

        var message = 'Field is required';
        for (var key in messages) {
          if (label.includes(key)) { message = messages[key]; break; }
        }

        errorEl.textContent = message;
      });
    }, 300);


    /* ── 2b. "Others" visibility toggle ── */
    waitForShadow(function (shadow) {
      function toggleOthers(retry) {
        retry = retry || 0;
        var selected   = shadow.querySelector('input[name="custom#how_did_you_hear_about_us_1"]:checked');
        var othersInput = shadow.querySelector('[id*="custom#others"]');

        if ((!selected || !othersInput) && retry < 10) {
          return setTimeout(function () { toggleOthers(retry + 1); }, 150);
        }
        if (!selected || !othersInput) return;

        var container = othersInput.closest('label') || othersInput.closest('div');
        if (!container) return;

        var isOther = selected.value.toLowerCase() === 'other';
        container.setAttribute('data-show', isOther ? 'true' : 'false');
        if (!isOther) othersInput.value = '';
      }

      shadow.addEventListener('change', function (e) {
        if (e.target.name === 'custom#how_did_you_hear_about_us_1') toggleOthers();
      });

      new MutationObserver(function () { toggleOthers(); })
        .observe(shadow, { childList: true, subtree: true });

      toggleOthers();
    });


    /* ── 2c. Move consent checkbox above submit (delayed 3 s) ── */
    setTimeout(function () {
      var shadow = getShadow();
      if (!shadow) return;

      var consent   = shadow.querySelector('._consentCheckboxContainer_cit2d_49');
      var submitBtn = shadow.querySelector('._formSubmitButton_cit2d_96');

      if (consent && submitBtn) {
        submitBtn.parentNode.insertBefore(consent, submitBtn);
      }
    }, 3000);


    /* ── 2d. File-type hint message ── */
    (function initFileMessages() {
      function addFileMessage() {
        var shadow = getShadow();
        if (!shadow) return;

        shadow.querySelectorAll('._formFileInputField_ehvsf_5').forEach(function (field) {
          if (field.nextElementSibling && field.nextElementSibling.classList.contains('custom-file-msg')) return;

          var msg = document.createElement('p');
          msg.className = 'custom-file-msg';
          msg.style.cssText = 'font-size:12px;margin-top:6px;color:#666;';
          msg.textContent = 'Supported file types include PDF, JPEG, PNG, WEBP, SVG, HEIC, and GIF. Files must be under 20 MB.';
          field.insertAdjacentElement('afterend', msg);
        });
      }

      addFileMessage();
      new MutationObserver(addFileMessage).observe(document.body, { childList: true, subtree: true });
    })();


    /* ── 2e. Custom legends + required stars ── */
    waitForShadow(function (shadow) {
      function applyLegends() {
        /* Text-input fields → floating custom legend */
        shadow.querySelectorAll('._formFieldContainer_1mxsl_5').forEach(function (field) {
          if (field.dataset.legendAdded) return;
          if (field.querySelector('input[type="tel"]')) return; // skip tel (handled separately)

          var lbl = field.querySelector('label');
          if (!lbl || !lbl.textContent.trim()) return;

          var legend = document.createElement('legend');
          legend.className = 'custom-legend _textBody_2aowh_10';
          legend.textContent = lbl.textContent.trim();
          field.insertBefore(legend, field.firstChild);
          field.dataset.legendAdded = 'true';
        });

        /* Add star to every legend that doesn't have one yet */
        shadow.querySelectorAll('legend').forEach(function (legend) {
          if (legend.querySelector('.required-star')) return;
          var star = document.createElement('span');
          star.className = 'required-star';
          star.textContent = ' *';
          legend.appendChild(star);
        });

        /* Add star to file-input <p> labels */
        shadow.querySelectorAll('._formFileInput_ehvsf_1 p._textBody_2aowh_10').forEach(function (p) {
          if (p.querySelector('.required-star')) return;
          if (p.textContent.toLowerCase().includes('vat certificate')) return;
          var star = document.createElement('span');
          star.className = 'required-star';
          star.textContent = ' *';
          p.appendChild(star);
        });

        /* Phone field → custom legend */
        shadow.querySelectorAll('._formPhoneInputContainer_piv1u_6').forEach(function (container) {
          if (container.dataset.legendAdded) return;

          var lbl = container.querySelector('label');
          if (!lbl || !lbl.textContent.trim()) return;

          var legend = document.createElement('legend');
          legend.className = 'custom-legend _textBody_2aowh_10 custom-legend-phone';

          legend.appendChild(document.createTextNode(lbl.textContent.trim()));
          var star = document.createElement('span');
          star.className = 'required-star';
          star.textContent = ' *';
          legend.appendChild(star);

          container.parentNode.insertBefore(legend, container);
          container.dataset.legendAdded = 'true';
        });
      }

      applyLegends();
      new MutationObserver(applyLegends).observe(shadow, { childList: true, subtree: true });
    });


    /* ── 2f. Hide floating label on focus / input ── */
    waitForShadow(function (shadow) {
      function isTargetInput(el) {
        return el.matches('input[type="text"], input[type="number"]');
      }

      function getLabelEl(field) {
        var container = field.closest('label') || field.closest('div');
        return container ? container.querySelector('label') : null;
      }

      shadow.addEventListener('focusin', function (e) {
        if (isTargetInput(e.target)) {
          var l = getLabelEl(e.target);
          if (l) l.classList.add('custom-hide-label');
        }
      });

      shadow.addEventListener('input', function (e) {
        if (isTargetInput(e.target)) {
          var l = getLabelEl(e.target);
          if (l) l.classList.add('custom-hide-label');
        }
      });

      shadow.addEventListener('focusout', function (e) {
        if (isTargetInput(e.target)) {
          var l = getLabelEl(e.target);
          if (l) {
            if (!e.target.value || !e.target.value.trim()) {
              l.classList.remove('custom-hide-label');
            }
          }
        }
      });
    });


    /* ── 2g. Blank-space validation ── */
    waitForShadow(function (shadow) {

      /* Inject error style once */
      injectStyle(shadow, 'b2b-trim-error-style', `
        .b2b-trim-error {
          color: red;
          font-size: 13px;
          margin-top: 4px;
          display: none;
        }
        .b2b-trim-error.visible {
          display: block !important;
        }
        input.b2b-input-invalid,
        textarea.b2b-input-invalid {
          outline: 1.5px solid red !important;
          border-color: red !important;
        }
      `);

      /**
       * Returns true if the value is non-empty after trimming.
       * Empty string, null, undefined, or whitespace-only → false.
       */
      function hasRealValue(val) {
        return typeof val === 'string' && val.trim().length > 0;
      }

      /**
       * Gets or creates the inline error element right after the input.
       */
      function getOrCreateError(input) {
        var next = input.nextElementSibling;
        if (next && next.classList.contains('b2b-trim-error')) return next;

        var err = document.createElement('div');
        err.className = 'b2b-trim-error';
        err.textContent = 'This field cannot be accept blank space.';
        input.parentNode.insertBefore(err, input.nextSibling);
        return err;
      }

      /** Mark an input as invalid */
      function markInvalid(input) {
        input.classList.add('b2b-input-invalid');
        var err = getOrCreateError(input);
        err.classList.add('visible');
      }

      /** Clear invalid state */
      function markValid(input) {
        input.classList.remove('b2b-input-invalid');
        var next = input.nextElementSibling;
        if (next && next.classList.contains('b2b-trim-error')) {
          next.classList.remove('visible');
        }
      }

      /**
       * Trim the input value in place and validate.
       * Returns true if valid (non-blank), false if blank.
       */
      function trimAndValidate(input) {
        /* Trim value in place so Shopify sees clean data */
        input.value = input.value.replace(/^\s+|\s+$/g, '');

        if (input.value.length === 0) {
          /* Only mark invalid if the field was previously touched/filled */
          /* We do NOT block truly empty required fields — Shopify handles those */
          return true; // treat empty as "not our concern" — Shopify handles required
        }

        /* Value exists but was whitespace-only before trim → block */
        markValid(input); // now has real content after trim
        return true;
      }

      /* ── Real-time: clear error as user types real chars ── */
      shadow.addEventListener('input', function (e) {
        var t = e.target;
        if (!t.matches('input[type="text"], input[type="number"], input[type="email"], textarea')) return;

        if (hasRealValue(t.value)) {
          markValid(t);
        }
      });

      /* ── On blur: trim & flag if only spaces were entered ── */
      shadow.addEventListener('focusout', function (e) {
        var t = e.target;
        if (!t.matches('input[type="text"], input[type="number"], input[type="email"], textarea')) return;

        var original = t.value;
        var trimmed  = original.trim();

        /* If user typed something but it's all spaces → flag it */
        if (original.length > 0 && trimmed.length === 0) {
          markInvalid(t);
          t.value = ''; // clear so Shopify required check also fires if needed
        } else {
          /* Silently trim leading/trailing spaces */
          t.value = trimmed;
          markValid(t);
        }
      });

      /* ── On submit: scan all text inputs for whitespace-only values ── */
      shadow.addEventListener('click', function (e) {
        var btn =
          e.target.closest("button[type='submit']") ||
          e.target.closest('[class*="formSubmitButton"]');

        if (!btn) return;

        var inputs = shadow.querySelectorAll(
          'input[type="text"], input[type="number"], input[type="email"], textarea'
        );

        var hasError = false;

        inputs.forEach(function (input) {
          var original = input.value;
          var trimmed  = original.trim();

          if (original.length > 0 && trimmed.length === 0) {
            /* Whitespace-only → reject */
            markInvalid(input);
            input.value = '';
            hasError = true;
          } else {
            /* Silently trim and accept */
            input.value = trimmed;
            markValid(input);
          }
        });

        if (hasError) {
          e.preventDefault();
          e.stopImmediatePropagation();

          /* Scroll to first invalid field */
          var firstInvalid = shadow.querySelector('.b2b-input-invalid');
          if (firstInvalid) {
            firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
            firstInvalid.focus();
          }
        }
      }, true /* capture: intercept before Shopify's own handler */);

    });

  }); // end DOMContentLoaded

})();


document.addEventListener('DOMContentLoaded', function () {
  function addSuccessLink() {
    var shadow = document.querySelector('shopify-forms-embed');
    if (!shadow || !shadow.shadowRoot) return;

    var banner = shadow.shadowRoot.querySelector('section[data-testid="banner-success"] ._textBody_2aowh_10');
    if (!banner || banner.querySelector('.success-link')) return;

    var link = document.createElement('a');
    link.className = 'success-link btn btn--primary';
    link.href = 'https://arethanaturalbeauty.com/';         // ← change this
    link.textContent = 'BACK TO HOMEPAGE';       // ← change this
    link.style.color = '#272727';
    link.style.textDecoration = 'none';

    banner.appendChild(link);
  }

  // Retry until the success banner appears (it only shows after submit)
  var observer = new MutationObserver(addSuccessLink);
  function waitForEmbed() {
    var embed = document.querySelector('shopify-forms-embed');
    if (!embed || !embed.shadowRoot) return setTimeout(waitForEmbed, 100);
    observer.observe(embed.shadowRoot, { childList: true, subtree: true });
  }
  waitForEmbed();
});

// Testimonial Section

document.addEventListener("DOMContentLoaded", () => {
  const reviewsWrap = document.querySelector(".reviews-wrap");

  if (!reviewsWrap) return;

  const contents = reviewsWrap.querySelectorAll(
    ".testimonial__content:not(:first-child)"
  );

  let maxHeight = 0;

  // Reset heights and find largest height
  contents.forEach((item) => {
    item.style.height = "auto";
    const itemHeight = item.offsetHeight;

    if (itemHeight > maxHeight) {
      maxHeight = itemHeight;
    }
  });

  // Apply largest height to all
  contents.forEach((item) => {
    item.style.height = `${maxHeight}px`;
  });
});